import type { ValidationResult } from '../types';

import type { PrePackageSearchState } from '../../../prepackage/prePackageStates';

export const usePrePackageValidation = (state: PrePackageSearchState, pristine: boolean): ValidationResult => {
    const hasTyped = !!state.destination?.trim();
    const hasSelected = !!state.destinationId;

    const validateState = (): boolean => {
        const validDestination = !hasTyped || hasSelected;
        const validFixedDeparture = state.searchType === 'fixed' && state.departureDate && state.returnDate;
        const validFlexibleDeparture = state.searchType === 'flexible';

        return validDestination && (validFixedDeparture || validFlexibleDeparture);
    };

    const invalid = {
        destination: !pristine && hasTyped && !hasSelected,
        departureDate: !pristine && state.searchType !== 'flexible' && !state.departureDate,
        returnDate: !pristine && state.searchType !== 'flexible' && !state.returnDate,
    };

    return { validateState, invalid };
};
